import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/de';

dayjs.extend(utc);

const TEMPLATE = 'YYYY-MM-DDTHH:mm:ss';
const DEFAULT_FORMAT = 'DD.MM.YYYY';
const FORMAT_MAP: { [locale: string]: string } = {
  'en-US': 'DD/MM/YYYY',
  'de-DE': 'DD/MM/YYYY',
};

export class DateHelper {
  static daysBack(minuend?: number): string {
    if (minuend === undefined) {
      return '';
    }
    return dayjs().subtract(minuend, 'days').format(TEMPLATE);
  }

  static hoursBack(minuend?: number): string {
    if (minuend === undefined) {
      return '';
    }
    return dayjs().subtract(minuend, 'hours').utc().toISOString();
  }

  static localize(date: Date, locale: string): string {
    return dayjs(date).format(FORMAT_MAP[locale] || DEFAULT_FORMAT);
  }
}

export const DEFAULT_DATE_RANGE = DateHelper.daysBack(28);
